import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Dashboard from "@/pages/Dashboard";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="*" element={<Dashboard />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                theme="dark"
                position="bottom-right"
                toastOptions={{
                    style: {
                        background: "#0A0A0A",
                        border: "1px solid #27272A",
                        borderRadius: 0,
                        color: "#fff",
                        fontFamily: "Montserrat",
                    },
                }}
            />
        </div>
    );
}

export default App;
